export function isTokenValid(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function getHost() {
  console.log(process.env.REACT_APP_ENVIRONMENT);
  return process.env.REACT_APP_ENVIRONMENT === "prod"
    ? "https://backend.thescrapingbook.com"
    : "http://localhost:3001";
}

export function defaultClientId(clients) {
  return clients?.length === 1 ? clients[0]._id : "";
}
